import { getPlainTextFromHtml } from "../../components/RichTextEditor";

export const getApiErrorMessage = (error, fallbackMessage) => {
  const detail = error?.response?.data?.detail;

  if (Array.isArray(detail)) {
    return detail
      .map((item) => {
        if (typeof item === "string") return item;
        if (item?.loc?.length) {
          const fieldName = item.loc[item.loc.length - 1];
          return `${fieldName} : ${item.msg}`;
        }
        return item?.msg || "Erreur de validation.";
      })
      .join(" | ");
  }

  if (typeof detail === "string") return detail;
  if (typeof error?.message === "string" && !error.response) return error.message;
  return fallbackMessage;
};

export const hasValidationErrorForField = (error, fieldName) => {
  const detail = error?.response?.data?.detail;
  if (!Array.isArray(detail)) return false;
  return detail.some((item) => Array.isArray(item?.loc) && item.loc[item.loc.length - 1] === fieldName);
};

export const getPreviewText = (html, maxLength = 150) => {
  const plain = getPlainTextFromHtml(html || "");
  if (plain.length <= maxLength) return plain;
  return `${plain.slice(0, maxLength).trim()}...`;
};

export const formatMinutesDuration = (value) => {
  const totalMinutes = Math.max(0, Number(value || 0));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours > 0 && minutes > 0) return `${hours} h ${minutes} min`;
  if (hours > 0) return `${hours} h`;
  return `${minutes} min`;
};

export const parseApiDate = (value) => {
  if (!value || typeof value !== "string") return new Date(value);
  const hasTimezone = /[zZ]$|[+-]\d{2}:\d{2}$/.test(value);
  return new Date(hasTimezone ? value : `${value}Z`);
};

export const formatDate = (value) =>
  parseApiDate(value).toLocaleString("fr-FR", {
    dateStyle: "medium",
    timeStyle: "short",
  });

export const formatOptionalDate = (value) => (value ? formatDate(value) : "Jamais");

export const getTmaUsagePercent = (total, remaining) => {
  const totalMinutes = Number(total || 0);
  if (totalMinutes <= 0) return 0;
  const usedMinutes = Math.max(0, totalMinutes - Number(remaining || 0));
  return Math.min(100, Math.round((usedMinutes / totalMinutes) * 100));
};

export const getInitials = (name) =>
  String(name || "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase() || "CL";

export const getClientTmaTone = (client) => {
  if (!client.tma_enabled || Number(client.tma_minutes_total || 0) <= 0) return "empty";
  const remaining = Number(client.tma_minutes_remaining || 0);
  if (remaining <= 60) return "danger";
  if (remaining <= 120) return "warning";
  return "success";
};

export const getTmaPackageRows = (packages, usedMinutes) => {
  let remainingUsed = Number(usedMinutes || 0);
  return (packages || []).map((item) => {
    const included = Number(item.minutes || 0);
    const used = Math.min(included, Math.max(remainingUsed, 0));
    remainingUsed -= used;
    return {
      ...item,
      used,
      remaining: Math.max(included - used, 0),
      progress: included > 0 ? Math.min(100, Math.round((used / included) * 100)) : 0,
    };
  });
};
